// extracted by mini-css-extract-plugin
export default {"simple_url":"link_simple_url__u1aOe"};